export const isDocumentFullscreen = documentRef =>
  Boolean(
    documentRef?.fullscreenElement ||
      documentRef?.webkitFullscreenElement ||
      documentRef?.msFullscreenElement
  )

export const isWindowFullscreen = win => {
  try {
    return isDocumentFullscreen(win?.document)
  } catch {
    return false
  }
}

export const isCustomerDisplayFullscreenConfirmation = message =>
  message?.isFullScreen === true

export const isCustomerDisplayFullscreenFailure = message =>
  message?.customerDisplayFullscreenFailed === true
